import { SbRrwebEvents } from 'sb-lib/types';

export type { SbPeerStatus as PeerStatus } from 'shared/realtime/sb-peer';

export enum Trigger {
  STREAM_EVENTS = 'STREAM_EVENTS',
  START_VIDEO = 'START_VIDEO',
  STOP_VIDEO = 'STOP_VIDEO',
  STOP_VIDEO_DECLINE = 'STOP_VIDEO_DECLINE_CALL',
  STOP_VIDEO_MISSED = 'STOP_VIDEO_MISSED_CALL',
  STOP_TAKEOVER = 'STOP_SCREENSHARE', // TODO: Rename me, breaking API change
  STOP_DISPLAYSHARE = 'STOP_DISPLAYSHARE',
  STOP_DISPLAYDEMO = 'STOP_DISPLAYDEMO',
  RESTART = 'RESTART',
  REJECT_CALL = 'REJECT_CALL',
  REJECT_TAKEOVER = 'REJECT_TAKEOVER',
  REJECT_DISPLAYSHARE = 'REJECT_DISPLAYSHARE',
}

export enum WidgetDataType {
  event = 'event',
  trigger = 'trigger',
  widgetState = 'widgetState',
  buildInformation = 'buildInformation',
}

export type WidgetEventData = {
  type: WidgetDataType.event;
  event: SbRrwebEvents;
  nonce: number;
};
export type WidgetTriggerData = { type: WidgetDataType.trigger; trigger: Trigger };
export type WidgetStateData = {
  type: WidgetDataType.widgetState;
  widgetState: WidgetState;
};
export type WidgetBuildInformationData = {
  type: WidgetDataType.buildInformation;
  hash: string;
  protocolVersion?: number;
};

export type WidgetData =
  | WidgetEventData
  | WidgetTriggerData
  | WidgetStateData
  | WidgetBuildInformationData;

export type WidgetState = {
  speakerStatus: 'on' | 'off' | 'none';
  micStatus: 'on' | 'off' | 'none';
  camStatus: 'on' | 'off' | 'none';
};

export enum VisitorAssociateErrorCode {
  ALREADY_ASSOCIATED = 'ALREADY_ASSOCIATED',
}

export type VisitorAssociationStatus =
  | 'off'
  | 'wanted' // will try to associate
  | 'establishing' // actively attempting association
  | 'active' // successfully associated
  | 'busy' // visitor associated with other
  | 'failed' // unknown error trying to associate
  | 'kicked' // another agent kicked you so they could associate
  | 'paused'; // want association, but it was cancelled

export type InteractionStatus = 'off' | 'establishing' | 'active' | 'rejected' | 'failed';

export type TakeoverEventType =
  | 'mousemove'
  | 'mouseup'
  | 'mousedown'
  | 'scroll'
  | 'click'
  | 'input'
  | 'change'
  | 'focusin'
  | 'focus'
  | 'blur'
  | 'focusin'
  | 'focusout';

export interface TakeoverEvent {
  selector: string;
  bubbles?: boolean;
  cancelable?: boolean;
  type: TakeoverEventType;
  value?: string;
  clientX?: number;
  clientY?: number;
  screenX?: number;
  screenY?: number;
  scrollTop?: number;
  scrollLeft?: number;
  checked?: boolean;
  detail?: number;
}

export type DrawEventType = 'draw';

export interface DrawEvent {
  type: DrawEventType;
  stop: boolean;
  x: number;
  y: number;
}

export type WidgetExtentEventType = 'widgetExtent';
export type WidgetExtent = 'normal' | 'collapsed' | 'maximized';

export interface WidgetExtentEvent {
  type: WidgetExtentEventType;
  extent: WidgetExtent;
}

export type ChatExpandedEventType = 'chatExpanded';
export interface ChatExpandedEvent {
  type: ChatExpandedEventType;
  expanded: boolean;
}
